import axios from "axios";
import Links from "@/shared/constants/Links";

export default {
  status: async () => axios.get(Links.notificationAccount.base),
  register: async () => axios.post(Links.notificationAccount.base),
  connect: async code => axios.post(Links.notificationAccount.connect, { code }),
};
